import axios from 'axios';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var JUMBO_URL = 'https://jumbo.zomato.com/event';
var URL_JUMBO_INIT = 'https://www.zomato.com/webroutes/webviews/zomatopay/getJumboInitConfig';
var JUMBO_MEMORY_TO_JUMBO_DURATION = 2000;
var PAGEVIEW_KEY = 'pageview';
var JUMBO_LS_KEY = '__jumbo__';
var ENAME_JUMBO_INIT_CONFIG_API_FAILED = 'webview-getJumboInitConfig-api-failed';

function isRavenWithCaptureException(obj) {
    return (!!obj &&
        typeof obj.captureException === 'function');
}
var addMultipleListeners = function (element, events, fn) {
    events.forEach(function (e) { return element.addEventListener(e, fn, false); });
};
var isBeaconSupported = function () {
    return !!(window.navigator && typeof window.navigator.sendBeacon === 'function');
};
var formatJumboEvents = function (raw_events) {
    return raw_events.map(function (event) {
        return {
            header: event.header,
            payload: event.payload,
        };
    });
};
var getJumboUrl = function (userId, url) {
    if (userId === void 0) { userId = 0; }
    if (url === void 0) { url = JUMBO_URL; }
    var parsedURL = new URL(url);
    if (userId !== 0) {
        parsedURL.searchParams.set('user_id', userId.toString());
    }
    return String(parsedURL);
};
var sendViaBeaconV2 = function (data, userId, url) {
    if (url === void 0) { url = JUMBO_URL; }
    var jumbo_url = getJumboUrl(userId, url);
    return (isBeaconSupported() &&
        navigator.sendBeacon(jumbo_url, JSON.stringify({ app_payload: data })));
};
function sendViaFetchV2(data, userId, url, zpwa) {
    if (url === void 0) { url = JUMBO_URL; }
    if (zpwa === void 0) { zpwa = false; }
    return __awaiter(this, void 0, void 0, function () {
        var request_params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request_params = {
                        no_zpwa: !zpwa,
                        method: 'POST',
                        body: JSON.stringify({ app_payload: data }),
                        extras: {
                            credentials: 'include',
                        },
                        query: { user_id: userId.toString() },
                    };
                    return [4 /*yield*/, axios.post(url, request_params)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
var ravenLog = function (msg) {
    if (!!window && isRavenWithCaptureException(window._Raven)) {
        window._Raven.captureException(new Error(msg));
    }
};
var isArray = function (arg) { return Array.isArray(arg); };
var isObject = function (arg) { return arg === Object(arg); };
var isLocalStorageSupported = function () { return !!window.localStorage; };
var convertToArray = function (events) {
    var events_array = [];
    if (isArray(events)) {
        events_array = events;
    }
    else if (isObject(events) || typeof events === 'string') {
        events_array = [events];
    }
    return events_array;
};

var Storage = /** @class */ (function () {
    function Storage() {
        this.hydrateMemoryFromLocalStorage = function () {
            try {
                if (isLocalStorageSupported()) {
                    var string_events = window.localStorage.getItem(JUMBO_LS_KEY);
                    var saved_events_arr = [];
                    if (string_events) {
                        saved_events_arr = JSON.parse(string_events);
                        if (isArray(saved_events_arr)) {
                            window.jumbo = saved_events_arr.concat(window.jumbo ? window.jumbo : []);
                        }
                    }
                    window.localStorage.removeItem(JUMBO_LS_KEY);
                }
            }
            catch (e) {
                ravenLog('Jumbo Error - hydrateMemoryFromLocalStorage - ' + e);
            }
        };
        this.getEventsArr = function () { return window.jumbo.slice(0); };
        this.addEventsArr = function (events) {
            window.jumbo = (isArray(window.jumbo) ? window.jumbo : []).concat(events);
        };
        this.saveEventsArr = function (events) {
            if (isLocalStorageSupported()) {
                window.localStorage.setItem(JUMBO_LS_KEY, JSON.stringify(events));
            }
        };
        this.clear = function () { return (window.jumbo = []); };
        this.hydrateMemoryFromLocalStorage();
    }
    return Storage;
}());

var instance = null;
var Jumbo = /** @class */ (function () {
    function Jumbo() {
        var _this = this;
        this.request_in_progress = false;
        this.jumbo_memory_flush_interval = null;
        this.session_id = '';
        this.device_id = '';
        this.url = '';
        this.user_id = 0;
        this.city_id = 0;
        this.is_zpwa = false;
        this.jumbo_interval = JUMBO_MEMORY_TO_JUMBO_DURATION;
        this.url_jumbo_init = URL_JUMBO_INIT;
        this.pageview_key = PAGEVIEW_KEY;
        this.lockRequest = function () {
            _this.request_in_progress = true;
        };
        this.unlockRequest = function () {
            _this.request_in_progress = false;
        };
        this.addEventListeners = function () {
            var events = ['blur', 'beforeunload', 'unload', 'online'];
            events = events.filter(function (event) {
                return Object.prototype.hasOwnProperty.call(window, 'on' + event);
            });
            addMultipleListeners(window, events, _this.sendEventsToJumbo);
        };
        this.preparePacket = function (key, values) {
            var modifiedValues = convertToArray(values);
            var url = document.URL;
            var formatted_events = modifiedValues.map(function (value) {
                return {
                    header: _this.getPacketHeader(),
                    payload: {
                        key: key,
                        value: value,
                        url: url,
                    },
                };
            });
            return formatted_events;
        };
        this.shouldSendRequest = function () {
            return navigator.onLine && !_this.request_in_progress;
        };
        this.setupCrons = function () {
            _this.jumbo_memory_flush_interval = setInterval(_this.sendEventsToJumbo, _this.jumbo_interval);
        };
        this.sendData = function (processed_events, raw_events) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isBeaconSupported()) return [3 /*break*/, 1];
                        sendViaBeaconV2(processed_events, this.user_id, this.url);
                        return [3 /*break*/, 4];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendViaFetchV2(processed_events, this.user_id, this.url, this.is_zpwa)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        this.storage.addEventsArr(raw_events);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.clearJumboMemoryFlushInterval = function () {
            if (_this.jumbo_memory_flush_interval) {
                clearInterval(_this.jumbo_memory_flush_interval);
            }
        };
        this.setParams = function (params) {
            _this.user_id = params.user_id || 0;
            _this.city_id = params.city_id || 0;
            _this.session_id = params.session_id || '';
            _this.device_id = params.device_id || '';
            _this.url = params.url || JUMBO_URL;
        };
        this.getCityId = function () { return _this.city_id; };
        this.getSessionId = function () { return _this.session_id; };
        this.getDeviceId = function () { return _this.device_id; };
        this.getPacketHeader = function () {
            var timestamp = Math.round(new Date().getTime() / 1000);
            var headerPayload = {
                location: _this.getCityId(),
                timestamp: timestamp,
            };
            if (_this.getSessionId()) {
                headerPayload.session_id = _this.getSessionId();
            }
            if (_this.getDeviceId()) {
                headerPayload.device_id = _this.getDeviceId();
            }
            return headerPayload;
        };
        this.initJumbo = function (config) { return __awaiter(_this, void 0, void 0, function () {
            var response, data, err_1, axiosError;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.is_zpwa = (_b = config === null || config === void 0 ? void 0 : config.is_zpwa) !== null && _b !== void 0 ? _b : false;
                        this.jumbo_interval =
                            (_c = config === null || config === void 0 ? void 0 : config.jumbo_interval) !== null && _c !== void 0 ? _c : JUMBO_MEMORY_TO_JUMBO_DURATION;
                        this.url_jumbo_init = (_d = config === null || config === void 0 ? void 0 : config.url_jumbo_init) !== null && _d !== void 0 ? _d : URL_JUMBO_INIT;
                        this.pageview_key = (_e = config === null || config === void 0 ? void 0 : config.pageview_key) !== null && _e !== void 0 ? _e : PAGEVIEW_KEY;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get(this.url_jumbo_init)];
                    case 2:
                        response = _f.sent();
                        data = response.data;
                        this.setParams({
                            city_id: data === null || data === void 0 ? void 0 : data.city_id,
                            user_id: data === null || data === void 0 ? void 0 : data.user_id,
                            device_id: data === null || data === void 0 ? void 0 : data.device_id,
                        });
                        window.z_user_city_id = data === null || data === void 0 ? void 0 : data.city_id;
                        window.z_user_id = data === null || data === void 0 ? void 0 : data.user_id;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _f.sent();
                        axiosError = err_1;
                        this.sendToJumbo(ENAME_JUMBO_INIT_CONFIG_API_FAILED, __assign({}, [axiosError.name, axiosError.message]));
                        this.setParams({});
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.sendToJumbo = function (key, values) {
            var formatted_events = _this.preparePacket(key, values);
            formatted_events.map(function (event) {
                window.jumbo.push(event);
            });
        };
        this.sendPageView = function (url) {
            _this.sendToJumbo(_this.pageview_key, url);
        };
        this.getEventsData = function () {
            var events = _this.storage.getEventsArr();
            var events_data = {
                raw_events: [],
                processed_events: [],
            };
            if (isArray(events) && events.length) {
                events_data.raw_events = events;
                events_data.processed_events = formatJumboEvents(events);
                _this.storage.clear();
            }
            return events_data;
        };
        this.sendEventsToJumbo = function () { return __awaiter(_this, void 0, void 0, function () {
            var _b, _c, raw_events, _d, processed_events;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = this.getEventsData(), _c = _b.raw_events, raw_events = _c === void 0 ? [] : _c, _d = _b.processed_events, processed_events = _d === void 0 ? [] : _d;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 4, , 5]);
                        if (!(raw_events.length && this.shouldSendRequest())) return [3 /*break*/, 3];
                        this.lockRequest();
                        return [4 /*yield*/, this.sendData(processed_events, raw_events)];
                    case 2:
                        _e.sent();
                        this.unlockRequest();
                        _e.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        _e.sent();
                        this.unlockRequest();
                        this.storage.addEventsArr(raw_events);
                        ravenLog('Jumbo Error - sendEventsToJumbo');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        window.jumbo = [];
        this.storage = new Storage();
        this.url = JUMBO_URL;
        this.setupCrons();
        this.addEventListeners();
    }
    var _a;
    _a = Jumbo;
    Jumbo.getInstance = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!instance) return [3 /*break*/, 2];
                    instance = new _a();
                    return [4 /*yield*/, instance.initJumbo(config)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/, instance];
            }
        });
    }); };
    return Jumbo;
}());

export { Jumbo, addMultipleListeners, convertToArray, formatJumboEvents, getJumboUrl, isArray, isBeaconSupported, isLocalStorageSupported, isObject, ravenLog, sendViaBeaconV2, sendViaFetchV2 };
